import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/scss/styles.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/maplibre-gl/dist/maplibre-gl.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@splidejs/react-splide/dist/css/splide-core.min.css");
